(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    // ===== WISHLIST / FAVORITE FUNCTIONALITY =====
  (function() {
    'use strict';

    const STORAGE_KEY = 'dwell_wishlist';
    const ACTIVE_CLASS = 'is-active';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch {
        return [];
      }
    }

    function saveWishlist(wishlist) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));
    }

    function showToast(message, isAdded) {
      const existing = document.querySelector('.wishlist-toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.innerHTML = `
        <svg class="wishlist-toast__icon" viewBox="0 0 24 24" fill="currentColor">
          ${isAdded 
            ? '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
            : '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="none" stroke="currentColor" stroke-width="2"/>'
          }
        </svg>
        <span>${message}</span>
      `;
      document.body.appendChild(toast);

      requestAnimationFrame(() => {
        toast.classList.add('show');
      });

      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 400);
      }, 2200);
    }

    function initFavoriteButton(button) {
      const productId = button.dataset.productId;
      const wishlist = getWishlist();

      if (wishlist.includes(productId)) {
        button.classList.add(ACTIVE_CLASS);
      }

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const wishlist = getWishlist();
        const index = wishlist.indexOf(productId);
        const isAdded = index === -1;

        if (isAdded) {
          wishlist.push(productId);
          button.classList.add(ACTIVE_CLASS);
          showToast('Added to your wishlist', true);
        } else {
          wishlist.splice(index, 1);
          button.classList.remove(ACTIVE_CLASS);
          showToast('Removed from wishlist', false);
        }

        saveWishlist(wishlist);

        document.dispatchEvent(new CustomEvent('wishlist:updated', {
          detail: { productId: productId, wishlist: wishlist, action: isAdded ? 'added' : 'removed' }
        }));
      });
    }

    // Initialize on DOM ready and on dynamic content changes
    function initAllFavorites() {
      document.querySelectorAll('.favorite-button[data-product-id]').forEach(initFavoriteButton);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFavorites);
    } else {
      initAllFavorites();
    }

    // Re-init for dynamically loaded content (infinite scroll, etc.)
    document.addEventListener('shopify:section:load', initAllFavorites);
    const observer = new MutationObserver((mutations) => {
      const hasNewCards = mutations.some(m => 
        Array.from(m.addedNodes).some(n => 
          n.nodeType === 1 && (n.matches?.('.product-card-wrapper') || n.querySelector?.('.product-card-wrapper'))
        )
      );
      if (hasNewCards) initAllFavorites();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
